import React from "react";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import { useAuth } from "../context/AuthProvider";

const ProfileFormComponent = () => {
  const { userDetail, logOut } = useAuth();

  return (
    <Container
      maxWidth="sm"
      sx={{
        marginTop: 4,
        marginBottom: 2,
        paddingBottom: "80px",
      }}
    >
      <Box
        className="border-box container_bg"
        sx={{
          alignItems: "center",
          borderRadius: "30px",
          padding: 2,
          // border: "1px solid #ddd",
          flexDirection: "row",
          marginBottom: 2,
        }}
      >
        <Box sx={{ marginBottom: 2 }}>
          {" "}
          <Typography variant="h6" className="typography_heading form_sub_head">
            Name
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            disabled={true}
            value={userDetail?.data?.user?.name || "NA"}
          />
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          {" "}
          <Typography variant="h6" className="typography_heading form_sub_head">
            Email
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            disabled={true}
            value={userDetail?.data?.user?.email || "NA"}
          />
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          {" "}
          <Typography variant="h6" className="typography_heading form_sub_head">
            Mobile
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            disabled={true}
            value={userDetail?.data?.user?.mobile || "NA"}
          />
        </Box>
        <Box sx={{ marginBottom: 2 }}>
          {" "}
          <Typography variant="h6" className="typography_heading form_sub_head">
            Reporting Manager Name
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            disabled={true}
            value={userDetail?.data?.user?.reportingManagerName || "NA"}
          />
        </Box>
      </Box>
      <Button type="submit" variant="contained" fullWidth onClick={logOut}>
        Logout
      </Button>
    </Container>
  );
};

export default ProfileFormComponent;
